import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: "Why choose Rishikesh for a destination wedding?",
      answer: "Rishikesh offers a unique blend of spirituality, natural beauty, and adventure. The sacred Ganges River, Himalayan backdrop, and serene atmosphere create an unforgettable wedding experience. Plus, it's affordable compared to other destination wedding locations in India."
    },
    {
      question: "What is included in your wedding packages?",
      answer: "Our packages include venue with Ganges accessibility, accommodation for guests (50-150 people based on package), vegetarian/multi-cuisine meals, floral decor, sound system, traditional Ganga Aarti arrangement, and wedding coordination. Higher-tier packages include professional DJ, mehendi setup, photography, and luxury amenities."
    },
    {
      question: "How much does a destination wedding in Rishikesh cost?",
      answer: "Our wedding packages start from ₹2,99,999 for 40-50 guests (Silver Package), ₹6,99,999 for 80-100 guests (Gold Package), and ₹9,99,999 for 125-150 guests (Platinum Package). All packages include 2 nights/3 days stay and are the best prices in Rishikesh."
    },
    {
      question: "What is the best time for a wedding in Rishikesh?",
      answer: "The best time for weddings in Rishikesh is October to March when the weather is pleasant. February to April and September to November are particularly popular for destination weddings. We recommend booking at least 6 months in advance."
    },
    {
      question: "Do you provide accommodation for guests?",
      answer: "Yes, all our packages include accommodation for guests. Silver package accommodates 50 guests, Gold package 80-100 guests, and Platinum package 120-150 guests. We offer comfortable riverside accommodations with modern amenities."
    },
    {
      question: "Can we customize the wedding package?",
      answer: "Absolutely! While we offer three standard packages, we're happy to create custom packages based on your specific requirements, guest count, budget, and preferences. Contact us for a personalized quote."
    },
    {
      question: "Is the venue accessible for elderly guests?",
      answer: "Yes, our venues are designed to be accessible for guests of all ages. We have proper pathways, seating arrangements, and assistance available for elderly guests to ensure their comfort throughout the celebration."
    },
    {
      question: "What activities can guests enjoy in Rishikesh?",
      answer: "Guests can enjoy morning yoga sessions, guided treks, Ganga Aarti ceremony, river rafting, temple visits, spa treatments, and meditation sessions. We can arrange customized activity packages based on your group's interests."
    },
    {
      question: "Do you arrange photography and videography?",
      answer: "Yes, our Gold and Platinum packages include professional photography. The Platinum package includes cinematic videography. We work with experienced photographers who specialize in destination wedding coverage."
    },
    {
      question: "How do I book a wedding date?",
      answer: "Contact us via phone (+91 98735 14657, +91 98111 73781, +91 98372 72408), WhatsApp, or our inquiry form. We'll check availability, schedule a venue visit if needed, and guide you through the booking process."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to know about planning your destination wedding in Rishikesh
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-b border-gray-200">
                <AccordionTrigger className="text-left hover:text-amber-700 py-4">
                  <span className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-4 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions?
          </p>
          <a
            href="#contact"
            className="inline-flex items-center text-amber-700 font-semibold hover:text-amber-800 transition-colors"
          >
            Contact our wedding planning team
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
